<template>
    <div>
        <span :class="{'cs-redLabel':!!data.Debt}">{{ data.Debt | toCurrency() }}</span>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
    
  },
  watch: {
    data: function() {
      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/accountListDebtCell.vue